<template>
  <div class="contact_index">
    <div class="us_information">
      <div class="map">
        <!-- <div id="allmap"></div> -->
        <div id="container"></div>
        <p>北京市石景山区五一剧场南路6号院1号楼4层402</p>
      </div>
      <div class="center">
        <ul class="clearfix">
          <li>
            <strong>广告合作</strong>
            <div class="contact_inf">
              <h5>广告投放合作 (北京)</h5>
              <p>联系人：崔先生</p>
              <p>邮箱：cuichunlei@adjuz.net</p>
              <p>微信：S-cchunlei</p>
              <p>电话：13241268017</p>
            </div>
            <!-- <div class="contact_inf">
              <h5>广告投放合作 (上海)</h5>
              <p>联系人：鲍先生</p>
              <p>邮箱：baoyang@adjuz.net</p>
              <p>电话：18360107746</p>
            </div>
            <div class="contact_inf">
              <h5>广告投放合作 (北京)</h5>
              <p>联系人：范女士</p>
              <p>邮箱：fanchunna@adjuz.net</p>
              <p>QQ：1161429499</p>
              <p>电话：18010063003</p>
            </div> -->
          </li>
          <li>
            <strong>其他合作</strong>
            <div class="contact_inf">
              <h5>开发者合作 (北京)</h5>
              <p>联系人：刘女士</p>
              <p>邮箱：liuwei@adjuz.net</p>
              <p>QQ：271966473</p>
              <p>电话：13552016263</p>
            </div>

            <div class="contact_inf">
              <h5>渠道合作 (北京)</h5>
              <p>联系人：刘女士</p>
              <p>邮箱：liuwei@adjuz.net</p>
              <p>QQ：271966473</p>
              <p>电话：13552016263</p>
            </div>
          </li>
          <li>
            <strong>公司地址</strong>
            <div class="contact_inf">
              <h5>北京总部</h5>
              <p>电话：010-56208704</p>
              <p>地址：北京市石景山区五一剧场南路6号院1号楼4层402</p>
              <p>邮编：100043</p>
            </div>
            <!-- <div class="contact_inf">
              <h5>广州公司</h5>
              <p>电话：13247693560</p>
              <p>地址：广州市天河区车陂路113号东宏国际广场8楼811单元</p>
              <p>邮编：510000</p>
            </div> -->
          </li>
        </ul>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {};
  },
  computed: {},
  components: {},
  created() { },
  destroyed() { },
  mounted() {
    var map = new AMap.Map("container", {
      zoom: 15, //级别
      center: [116.151621, 39.915725], //中心点坐标
      viewMode: "3D", //使用3D视图
    });

    //map.setStatus({
    // dragEnable: false,
    // keyboardEnable: false,
    // doubleClickZoom: false,
    // zoomEnable: false,
    // rotateEnable: false
    //});

    var marker = new AMap.Marker({
      position: new AMap.LngLat(116.151621, 39.915725),
      offset: new AMap.Pixel(-20, -10),
      icon: require("./logo.png"), // 添加 Icon 图标 URL
      title: "北京",
    });

    map.add(marker);
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.contact_index {
  background: #fff;
  #container {
    width: 100%;
    height: 480px;
  }
  #allmap {
    height: 480px;
  }
  .map p {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #929292;
    text-align: center;
    border-bottom: 1px solid #eaeaea;
  }
  .center {
    width: 1200px;
    margin: 0 auto;
    z-index: 5;
    padding: 86px 0 100px;
  }
  .us_information ul {
    display: flex;
  }
  .us_information li {
    width: 400px;
  }
  .us_information li strong {
    width: 290px;
    height: 51px;
    line-height: 51px;
    margin-left: 90px;
    font-size: 34px;
    font-weight: normal;
    display: block;
  }
  .us_information li h5 {
    font-size: 18px !important;
    font-weight: bold;
  }
  .us_information li p,
  .us_information li h5 {
    width: 250px;
    margin-left: 90px;
  }
  .us_information li p {
    width: 280px;
  }
  .us_information .contact_inf {
    width: 290px;
    margin-top: 38px;
  }
  .us_information li h5 {
    height: 30px;
    line-height: 30px;
    padding-bottom: 17px;
    font-size: 20px;
  }
  .us_information li p {
    line-height: 29px;
    font-size: 16px;
    color: #575757;
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/contact/index.vue